import React, { useEffect, useState } from "react";
import { notification } from "antd";
import {
  InfoCircleOutlined,
  CheckCircleOutlined,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { addEditData } from "../../../../controllers/V1/cms/pickupPointsDataController";

import ImageUploader from "../../../../components/ImageUploader/ImgUploader";
import { ASSETS_BASE_URL } from "../../../../config/constants";

const BannerAddEditData = () => {
  const location = useLocation();
  const state = location.state;
  const navigate = useNavigate();
  const [error, setError] = useState([]);
  const [ADDEDITDATA, setAddEditData] = useState(state || []);
  const [showUploader, setShowUploader] = useState(false);
  const toggleImgUploader = () => setShowUploader(!showUploader);
  const [imageUrl, setImageUrl] = useState(state?.image || "");

  // const [isLoading, setIsLoading] = useState(false);

  /*********************************************************
   *  This function is use to handle input change
   *********************************************************/
  const handleChange = (e) => {
    setAddEditData((pre) => ({
      ...pre,
      [e.target.name]: e.target.value,
    }));
    setError((pre) => ({
      ...pre,
      [e.target.name]: "",
    }));
  };

  /*********************************************************
   *  This function is use to handle form submit
   *********************************************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const form = new FormData(event.target);

      const params = {
        ...(form.get("editId") && { editId: form.get("editId") }),
        name: form.get("name"),
        mobile: form.get("mobile"),
        address: form.get("address"),
        seq_order : form.get("seq_order") || 1
      };
      console.log("params :", params);
      const isValidate = await validateFormData(params);
      if (isValidate === true) {
        const res = await addEditData(params);
        if (res.status === true) {
          notification.open({
            message: "Success.",
            description: `Data successfully added.`,
            placement: "topRight",
            icon: <CheckCircleOutlined style={{ color: "green" }} />,
            duration: 2,
          });
          navigate("/cms/pickup-point/list");
        } else {
          notification.open({
            message: "Oops!.",
            description: `${res.message}`,
            placement: "topRight",
            icon: <InfoCircleOutlined style={{ color: "red" }} />,
            duration: 2,
          });
        }
      } else {
        // console.log('validation error',error);
        notification.open({
          message: "Oops!",
          description: `Validation Error.`,
          placement: "topRight",
          icon: <InfoCircleOutlined style={{ color: "red" }} />,
          duration: 2,
        });
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  /*********************************************************
   *  This function is used to validate form data before submit
   *********************************************************/
  const validateFormData = (formData) => {
    try {
      const { name, mobile, address } = formData;

      let status = false;
      let msg = "noError";
      let error_field = "noError";

      if (!name) {
        error_field = "name";
        msg = "Name is required.";
        status = false;
      } else if (!mobile) {
        error_field = "mobile";
        msg = "Mobile on is required.";
        status = false;
      } else if (!address) {
        error_field = "address";
        msg = "Address is required.";
        status = false;
      } else {
        status = true;
      }

      if (!status && setError) {
        setError((prevError) => ({
          ...prevError,
          [error_field]: msg,
        }));
      }

      return status;
    } catch (error) {
      console.log("error", error);
      return false;
    }
  };

  useEffect(() => {
    document.title = `Crown-King || ${
      ADDEDITDATA?._id ? "Edit" : "Add"
    } Pickup point`;
  }, []);
  return (
    <div>
      {" "}
      <div className="container-fluid">
        <div className="Inventory_edit_page_main_div">
          <React.Fragment>
            <h5 className="inventory_edit_page_heading">
              {" "}
              {ADDEDITDATA?._id ? `Edit` : `Add`} Pickup Points{" "}
            </h5>
          </React.Fragment>
          <Link to={"/cms/pickup-point/list"}>
            <React.Fragment>
              <button type="button" className="btn btn-secondary">
                {" "}
                <ArrowLeftOutlined /> Back{" "}
              </button>
            </React.Fragment>
          </Link>
        </div>

        <div className="card shadow mb-4 dataBase_table_Add_Data">
          <div className="card-body">
            <div className="responsive">
              <form
                method="post"
                className="inventory_form_main_contnet"
                onSubmit={handleSubmit}
              >
                <input
                  type="hidden"
                  name="editId"
                  id="editId"
                  value={ADDEDITDATA._id || ""}
                />

                <div className="row">
                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="name"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span> Name:
                    </label>
                    <input
                      type="text"
                      title="Name"
                      name="name"
                      className="form-control store_input_field"
                      id="name"
                      placeholder="Name"
                      value={ADDEDITDATA?.name} 
                      onChange={handleChange}
                    />
                    {error.page && <p style={{ color: "red" }}>{error.page}</p>}
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="mobile"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Mobile:
                    </label>
                    <input
                      type="number"
                      title="Mobile"
                      name="mobile"
                      className="form-control store_input_field"
                      id="mobile"
                      placeholder="Mobile"
                      value={ADDEDITDATA?.mobile} 
                      onChange={handleChange}
                    />
                    {error.show_on && (
                      <p style={{ color: "red" }}>{error.show_on}</p>
                    )}
                  </div>

                  <div className="form-group col-lg-4 col-md-6 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="seq_order"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Seq. Order:
                    </label>
                    <input
                      type="number"
                      title="seq_order"
                      name="seq_order"
                      className="form-control store_input_field"
                      id="seq_order"
                      placeholder="Seq. Order"
                      value={ADDEDITDATA?.seq_order} 
                      onChange={handleChange}
                    />
                    {error.show_on && (
                      <p style={{ color: "red" }}>{error.show_on}</p>
                    )}
                  </div>

                  <div className="form-group col-lg-12 col-md-12 col-sm-12 col-xs-12 vendor_Add_edit_data">
                    <label
                      htmlFor="address"
                      className="all_section_for_label_main_class"
                    >
                      <span style={{ color: "red" }}>*</span>Address:
                    </label>
                    <input
                      type="text"
                      title="Address"
                      name="address"
                      className="form-control store_input_field"
                      id="address"
                      placeholder="Address"
                      value={ADDEDITDATA?.address} 
                      onChange={handleChange}
                    />
                      
                    {error.address && (
                      <p style={{ color: "red" }}>{error.address}</p>
                    )}
                  </div>
                </div>

                <div className="inventory_edit_submit_btn">
                  <button
                    type="submit"
                    className="btn btn-primary inventory_save_button"
                  >
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BannerAddEditData;
